import React, { FC } from 'react'

import ProductTemplateDesktopLayout from './ProductTemplateDesktopLayout'
import ProductTemplateMobileLayout from './ProductTemplateMobileLayout'

// TODO: update to one layout
const ProductTemplateLayout: FC = () => {
  return (
    <>
      <ProductTemplateMobileLayout />
      <ProductTemplateDesktopLayout />
    </>
  )
}

export default ProductTemplateLayout
